/**
 * いま見ている放送を SNS へ持っていくための文面（要件定義 17 章）。
 *
 * 文面の決まりは .claude/skills/sns-post/SKILL.md と揃えてある。
 * とくに次の 3 つは崩さない。
 *
 * - 「非公式」または「ファン」が本文に入る（要件定義 14 章）
 * - 公式・公認と読める語を使わない
 * - X の 140 字に収まる（URL は全角 11.5 字ぶんとして計上される）
 */

import { SITE } from '~/lib/site'

/** シェアで開く URL。末尾スラッシュ付きで統一する */
export const SHARE_URL = `${SITE.url}/`

/**
 * 本文に入れる番組名の上限。
 * YouTube の動画名は長いものが多く、そのまま入れると X の字数に収まらない。
 */
const TITLE_MAX_LENGTH = 30

/** 番組名を字数で切る。切ったことが分かるように「…」を付ける */
export const truncateTitle = (title: string): string => {
  const characters = [...title.trim()]
  if (characters.length <= TITLE_MAX_LENGTH) return characters.join('')
  return `${characters.slice(0, TITLE_MAX_LENGTH - 1).join('')}…`
}

/**
 * シェアの本文。URL は含めない。
 *
 * Web Share API も X の投稿画面も URL を別に受け取り、本文の後ろへ自分で付ける。
 * 本文にも書くと URL が二重に並ぶ。
 */
export const shareBody = (title?: string): string => {
  const headline = title
    ? `いま834CHで「${truncateTitle(title)}」が流れています🐟`
    : '834CHを見ています🐟'

  return [
    headline,
    '',
    'サカナクションと山口一郎の動画が番組表に沿って流れる、ファンの非公式ネットテレビです。',
    '',
    '#834CH #同時視聴',
  ].join('\n')
}

/** X の投稿画面。本文の後ろに URL が付く */
export const xIntentUrl = (body: string): string => {
  const url = new URL('https://x.com/intent/post')
  url.searchParams.set('text', body)
  url.searchParams.set('url', SHARE_URL)
  return url.toString()
}

/**
 * 共有シートを開く。使えない環境では X の投稿画面を開く。
 *
 * 共有シートを閉じただけのときも reject されるので、失敗しても何も出さない。
 */
export const shareBroadcast = async (title?: string): Promise<void> => {
  const body = shareBody(title)

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: SITE.name, text: body, url: SHARE_URL })
      return
    } catch {
      // 共有シートを閉じた場合もここに来る。X へ振り替えず、そのまま終える
      return
    }
  }

  window.open(xIntentUrl(body), '_blank', 'noopener,noreferrer')
}
